const _excluded = ["ref"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useObjectRef as $iETbY$useObjectRef, mergeRefs as $iETbY$mergeRefs, mergeProps as $iETbY$mergeProps, useLayoutEffect as $iETbY$useLayoutEffect } from "@react-aria/utils";
import $iETbY$react, { useMemo as $iETbY$useMemo, useContext as $iETbY$useContext, useState as $iETbY$useState, useRef as $iETbY$useRef, useCallback as $iETbY$useCallback } from "react";

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $64fa3d84918910a7$export$c62b8e45d58ddad9 = Symbol('default');
function $64fa3d84918910a7$export$2881499e37b75b9a(_ref) {
  let values = _ref.values,
    children = _ref.children;
  for (let _ref2 of values) {
    var _ref3 = _slicedToArray(_ref2, 2);
    let Context = _ref3[0];
    let value = _ref3[1];
    // @ts-ignore
    children = /*#__PURE__*/(0, $iETbY$react).createElement(Context.Provider, {
      value: value
    }, children);
  }
  return children;
}
function $64fa3d84918910a7$export$4d86445c2cf5e3(props) {
  let className = props.className,
    style = props.style,
    children = props.children,
    defaultClassName = props.defaultClassName,
    defaultChildren = props.defaultChildren,
    defaultStyle = props.defaultStyle,
    values = props.values;
  return (0, $iETbY$useMemo)(() => {
    let computedClassName;
    let computedStyle;
    let computedChildren;
    if (typeof className === 'function') computedClassName = className(_objectSpread(_objectSpread({}, values), {}, {
      defaultClassName: defaultClassName
    }));else computedClassName = className;
    if (typeof style === 'function') computedStyle = style(_objectSpread(_objectSpread({}, values), {}, {
      defaultStyle: defaultStyle || {}
    }));else computedStyle = style;
    if (typeof children === 'function') computedChildren = children(_objectSpread(_objectSpread({}, values), {}, {
      defaultChildren: defaultChildren
    }));else if (children == null) computedChildren = defaultChildren;else computedChildren = children;
    return {
      className: computedClassName !== null && computedClassName !== void 0 ? computedClassName : defaultClassName,
      style: computedStyle || defaultStyle ? _objectSpread(_objectSpread({}, defaultStyle), computedStyle) : undefined,
      children: computedChildren !== null && computedChildren !== void 0 ? computedChildren : defaultChildren,
      'data-rac': ''
    };
  }, [className, style, children, defaultClassName, defaultChildren, defaultStyle, values]);
}
function $64fa3d84918910a7$export$c245e6201fed2f75(
// https://stackoverflow.com/questions/60898079/typescript-type-t-or-function-t-usage
value, wrap) {
  return renderProps => wrap(typeof value === 'function' ? value(renderProps) : value, renderProps);
}
function $64fa3d84918910a7$export$fabf2dc03a41866e(context, slot) {
  let ctx = (0, $iETbY$useContext)(context);
  if (slot === null)
    // An explicit `null` slot means don't use context.
    return null;
  if (ctx && typeof ctx === 'object' && 'slots' in ctx && ctx.slots) {
    let availableSlots = new Intl.ListFormat().format(Object.keys(ctx.slots).map(p => `"${p}"`));
    if (!slot && !ctx.slots[$64fa3d84918910a7$export$c62b8e45d58ddad9]) throw new Error(`A slot prop is required. Valid slot names are ${availableSlots}.`);
    let slotKey = slot || $64fa3d84918910a7$export$c62b8e45d58ddad9;
    if (!ctx.slots[slotKey])
      // @ts-ignore
      throw new Error(`Invalid slot "${slot}". Valid slot names are ${availableSlots}.`);
    return ctx.slots[slotKey];
  }
  // @ts-ignore
  return ctx;
}
function $64fa3d84918910a7$export$29f1550f4b0d4415(props, ref, context) {
  let ctx = $64fa3d84918910a7$export$fabf2dc03a41866e(context, props.slot) || {};
  // @ts-ignore - TS says "Type 'unique symbol' cannot be used as an index type." but not sure why.
  let contextRef = ctx.ref,
    contextProps = _objectWithoutProperties(ctx, _excluded);
  let mergedRef = (0, $iETbY$useObjectRef)((0, $iETbY$useMemo)(() => (0, $iETbY$mergeRefs)(ref, contextRef), [ref, contextRef]));
  let mergedProps = (0, $iETbY$mergeProps)(contextProps, props);
  // mergeProps does not merge `style`. Adding this there might be a breaking change.
  if ('style' in contextProps && contextProps.style && 'style' in props && props.style) {
    if (typeof contextProps.style === 'function' || typeof props.style === 'function')
      // @ts-ignore
      mergedProps.style = renderProps => {
        let contextStyle = typeof contextProps.style === 'function' ? contextProps.style(renderProps) : contextProps.style;
        let defaultStyle = _objectSpread(_objectSpread({}, renderProps.defaultStyle), contextStyle);
        let style = typeof props.style === 'function' ? props.style(_objectSpread(_objectSpread({}, renderProps), {}, {
          defaultStyle: defaultStyle
        })) : props.style;
        return _objectSpread(_objectSpread({}, defaultStyle), style);
      };else
      // @ts-ignore
      mergedProps.style = _objectSpread(_objectSpread({}, contextProps.style), props.style);
  }
  return [mergedProps, mergedRef];
}
function $64fa3d84918910a7$export$9d4c57ee4c6ffdd8() {
  // Assume we do have the slot in the initial render.
  let _ref4 = (0, $iETbY$useState)(true),
    _ref5 = _slicedToArray(_ref4, 2),
    hasSlot = _ref5[0],
    setHasSlot = _ref5[1];
  let hasRun = (0, $iETbY$useRef)(false);
  // A callback ref which will run when the slotted element mounts.
  // This should happen before the useLayoutEffect below.
  let ref = (0, $iETbY$useCallback)(el => {
    hasRun.current = true;
    setHasSlot(!!el);
  }, []);
  // If the callback hasn't been called, then reset to false.
  (0, $iETbY$useLayoutEffect)(() => {
    if (!hasRun.current) setHasSlot(false);
  }, []);
  return [ref, hasSlot];
}
function $64fa3d84918910a7$export$ef03459518577ad4(props) {
  const prefix = /^(data-.*)$/;
  let filteredProps = {};
  for (const prop in props) if (!prefix.test(prop)) filteredProps[prop] = props[prop];
  return filteredProps;
}
export { $64fa3d84918910a7$export$c62b8e45d58ddad9 as DEFAULT_SLOT, $64fa3d84918910a7$export$2881499e37b75b9a as Provider, $64fa3d84918910a7$export$4d86445c2cf5e3 as useRenderProps, $64fa3d84918910a7$export$c245e6201fed2f75 as composeRenderProps, $64fa3d84918910a7$export$fabf2dc03a41866e as useSlottedContext, $64fa3d84918910a7$export$29f1550f4b0d4415 as useContextProps, $64fa3d84918910a7$export$9d4c57ee4c6ffdd8 as useSlot, $64fa3d84918910a7$export$ef03459518577ad4 as removeDataAttributes };